// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  .template-page {
    min-height: 100vh;
    background-color: #1a2332;
    padding: 120px 60px 60px 60px;
  }
  
  .template-container {
    background-color: white;
    border-radius: 12px;
    height: calc(100vh - 180px);
    display: flex;
    flex-direction: column;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .template-header {
    padding: 15px 30px;
    border-bottom: 1px solid #e0e0e0;
    min-height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .template-header h2 {
    font-size: 20px;
    font-weight: 600;
    color: #333;
  }
  
  .template-messages {
    flex: 1 1;
    padding: 30px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-size: 18px;
    color: #999;
    gap: 10px;
    text-align: center;
  }
  
  .message-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 15px;
    margin-left: auto;
    max-width: 80%;
  }
  
  .message-content {
    background-color: #f5f5f5;
    padding: 12px 18px;
    border-radius: 12px;
    font-size: 15px;
    color: #333;
    word-wrap: break-word;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .code-preview-button {
    padding: 8px 16px;
    background-color: #4CAF50;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease;
    align-self: flex-start;
  }
  
  .code-preview-button:hover {
    background-color: #45a049;
  }
  
  .user-icon {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    background-color: #e0e0e0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .template-input-container {
    border-top: 1px solid #e0e0e0;
    padding: 20px 30px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .code-status-button {
    padding: 8px 16px;
    background-color: #4CAF50;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease;
    align-self: flex-start;
  }
  
  .code-status-button:hover {
    background-color: #45a049;
  }
  
  .input-row {
    display: flex;
    gap: 15px;
    align-items: center;
  }
  
  .add-code-button {
    width: 40px;
    height: 40px;
    background-color: #2196F3;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 24px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  
  .add-code-button:hover {
    background-color: #1976D2;
  }
  
  .message-input {
    flex: 1 1;
    padding: 12px 20px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    font-size: 15px;
    outline: none;
    transition: border-color 0.3s ease;
  }
  
  .message-input:focus {
    border-color: #2196F3;
  }
  
  .message-input::placeholder {
    color: #999;
  }
  
  .send-button {
    padding: 12px 30px;
    background-color: #2196F3;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease;
    white-space: nowrap;
  }
  
  .send-button:hover {
    background-color: #1976D2;
  }
  
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(26, 35, 50, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  
  .modal-content {
    background-color: #2c3e50;
    border-radius: 12px;
    padding: 30px;
    width: 90%;
    max-width: 700px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    gap: 20px;
    position: relative;
  }
  
  .close-button {
    position: absolute;
    top: 15px;
    right: 15px;
    width: 32px;
    height: 32px;
    background-color: transparent;
    color: white;
    border: none;
    font-size: 28px;
    cursor: pointer;
    transition: color 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .close-button:hover {
    color: #ff6b6b;
  }
  
  .modal-content h3 {
    color: white;
    font-size: 22px;
    font-weight: 600;
  }
  
  .code-textarea {
    background-color: #34495e;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 15px;
    font-size: 14px;
    font-family: 'Courier New', monospace;
    resize: vertical;
    min-height: 300px;
    outline: none;
  }
  
  .code-textarea::placeholder {
    color: #95a5a6;
  }
  
  .modal-buttons {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
  }
  
  .modal-save-button,
  .modal-delete-button,
  .modal-cancel-button {
    padding: 10px 24px;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .modal-save-button {
    background-color: #4CAF50;
    color: white;
  }
  
  .modal-save-button:hover {
    background-color: #45a049;
  }
  
  .modal-delete-button {
    background-color: #ff6b6b;
    color: white;
  }
  
  .modal-delete-button:hover {
    background-color: #ff9e9e;
  }
  
  .modal-cancel-button {
    background-color: #7f8c8d;
    color: white;
  }
  
  .modal-cancel-button:hover {
    background-color: #6c7a7b;
  }
  
  @media (max-width: 1024px) {
    .template-page {
      padding: 100px 40px 40px 40px;
    }
    
    .template-container {
      height: calc(100vh - 140px);
    }
  }
  
  @media (max-width: 768px) {
    .template-page {
      padding: 80px 20px 20px 20px;
    }
    
    .template-container {
      height: calc(100vh - 100px);
    }
    
    .template-header {
      padding: 12px 20px;
      min-height: 50px;
    }
    
    .template-header h2 {
      font-size: 18px;
    }
    
    .template-messages {
      padding: 20px;
    }
    
    .message-row {
      max-width: 90%;
    }
    
    .template-input-container {
      padding: 15px 20px;
    }
    
    .modal-content {
      width: 95%;
      padding: 20px;
    }
    
    .modal-buttons {
      flex-direction: column;
    }
    
    .modal-save-button,
    .modal-delete-button,
    .modal-cancel-button {
      width: 100%;
    }
  }
  
  @media (max-width: 480px) {
    .template-page {
      padding: 60px 15px 15px 15px;
    }
    
    .template-header h2 {
      font-size: 16px;
    }
    
    .template-messages {
      padding: 15px;
    }
    
    .empty-state {
      font-size: 16px;
    }
    
    .message-content {
      font-size: 14px;
      padding: 10px 15px;
    }
    
    .user-icon {
      width: 32px;
      height: 32px;
    }
    
    .add-code-button {
      width: 36px;
      height: 36px;
      font-size: 20px;
    }
    
    .message-input {
      padding: 10px 15px;
      font-size: 14px;
    }
    
    .send-button {
      padding: 10px 20px;
      font-size: 14px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/covfile/Template.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,kCAAkC;EACpC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,qCAAqC;IACrC,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,yBAAyB;EAC3B;;EAEA;;;IAGE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,6BAA6B;IAC/B;;IAEA;MACE,2BAA2B;IAC7B;EACF;;EAEA;IACE;MACE,4BAA4B;IAC9B;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,UAAU;MACV,aAAa;IACf;;IAEA;MACE,sBAAsB;IACxB;;IAEA;;;MAGE,WAAW;IACb;EACF;;EAEA;IACE;MACE,4BAA4B;IAC9B;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,eAAe;IACjB;;IAEA;MACE,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,kBAAkB;MAClB,eAAe;IACjB;EACF","sourcesContent":["* {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  .template-page {\r\n    min-height: 100vh;\r\n    background-color: #1a2332;\r\n    padding: 120px 60px 60px 60px;\r\n  }\r\n  \r\n  .template-container {\r\n    background-color: white;\r\n    border-radius: 12px;\r\n    height: calc(100vh - 180px);\r\n    display: flex;\r\n    flex-direction: column;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .template-header {\r\n    padding: 15px 30px;\r\n    border-bottom: 1px solid #e0e0e0;\r\n    min-height: 60px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .template-header h2 {\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    color: #333;\r\n  }\r\n  \r\n  .template-messages {\r\n    flex: 1;\r\n    padding: 30px;\r\n    overflow-y: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n  }\r\n  \r\n  .empty-state {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 100%;\r\n    font-size: 18px;\r\n    color: #999;\r\n    gap: 10px;\r\n    text-align: center;\r\n  }\r\n  \r\n  .message-row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n    gap: 15px;\r\n    margin-left: auto;\r\n    max-width: 80%;\r\n  }\r\n  \r\n  .message-content {\r\n    background-color: #f5f5f5;\r\n    padding: 12px 18px;\r\n    border-radius: 12px;\r\n    font-size: 15px;\r\n    color: #333;\r\n    word-wrap: break-word;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n  }\r\n  \r\n  .code-preview-button {\r\n    padding: 8px 16px;\r\n    background-color: #4CAF50;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 6px;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n    align-self: flex-start;\r\n  }\r\n  \r\n  .code-preview-button:hover {\r\n    background-color: #45a049;\r\n  }\r\n  \r\n  .user-icon {\r\n    flex-shrink: 0;\r\n    width: 36px;\r\n    height: 36px;\r\n    background-color: #e0e0e0;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .template-input-container {\r\n    border-top: 1px solid #e0e0e0;\r\n    padding: 20px 30px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n  }\r\n  \r\n  .code-status-button {\r\n    padding: 8px 16px;\r\n    background-color: #4CAF50;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 6px;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n    align-self: flex-start;\r\n  }\r\n  \r\n  .code-status-button:hover {\r\n    background-color: #45a049;\r\n  }\r\n  \r\n  .input-row {\r\n    display: flex;\r\n    gap: 15px;\r\n    align-items: center;\r\n  }\r\n  \r\n  .add-code-button {\r\n    width: 40px;\r\n    height: 40px;\r\n    background-color: #2196F3;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    font-size: 24px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-shrink: 0;\r\n  }\r\n  \r\n  .add-code-button:hover {\r\n    background-color: #1976D2;\r\n  }\r\n  \r\n  .message-input {\r\n    flex: 1;\r\n    padding: 12px 20px;\r\n    border: 2px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    font-size: 15px;\r\n    outline: none;\r\n    transition: border-color 0.3s ease;\r\n  }\r\n  \r\n  .message-input:focus {\r\n    border-color: #2196F3;\r\n  }\r\n  \r\n  .message-input::placeholder {\r\n    color: #999;\r\n  }\r\n  \r\n  .send-button {\r\n    padding: 12px 30px;\r\n    background-color: #2196F3;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n    white-space: nowrap;\r\n  }\r\n  \r\n  .send-button:hover {\r\n    background-color: #1976D2;\r\n  }\r\n  \r\n  .modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background-color: rgba(26, 35, 50, 0.85);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .modal-content {\r\n    background-color: #2c3e50;\r\n    border-radius: 12px;\r\n    padding: 30px;\r\n    width: 90%;\r\n    max-width: 700px;\r\n    max-height: 80vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    position: relative;\r\n  }\r\n  \r\n  .close-button {\r\n    position: absolute;\r\n    top: 15px;\r\n    right: 15px;\r\n    width: 32px;\r\n    height: 32px;\r\n    background-color: transparent;\r\n    color: white;\r\n    border: none;\r\n    font-size: 28px;\r\n    cursor: pointer;\r\n    transition: color 0.3s ease;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .close-button:hover {\r\n    color: #ff6b6b;\r\n  }\r\n  \r\n  .modal-content h3 {\r\n    color: white;\r\n    font-size: 22px;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .code-textarea {\r\n    background-color: #34495e;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    padding: 15px;\r\n    font-size: 14px;\r\n    font-family: 'Courier New', monospace;\r\n    resize: vertical;\r\n    min-height: 300px;\r\n    outline: none;\r\n  }\r\n  \r\n  .code-textarea::placeholder {\r\n    color: #95a5a6;\r\n  }\r\n  \r\n  .modal-buttons {\r\n    display: flex;\r\n    gap: 12px;\r\n    justify-content: flex-end;\r\n  }\r\n  \r\n  .modal-save-button,\r\n  .modal-delete-button,\r\n  .modal-cancel-button {\r\n    padding: 10px 24px;\r\n    border: none;\r\n    border-radius: 8px;\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n  }\r\n  \r\n  .modal-save-button {\r\n    background-color: #4CAF50;\r\n    color: white;\r\n  }\r\n  \r\n  .modal-save-button:hover {\r\n    background-color: #45a049;\r\n  }\r\n  \r\n  .modal-delete-button {\r\n    background-color: #ff6b6b;\r\n    color: white;\r\n  }\r\n  \r\n  .modal-delete-button:hover {\r\n    background-color: #ff9e9e;\r\n  }\r\n  \r\n  .modal-cancel-button {\r\n    background-color: #7f8c8d;\r\n    color: white;\r\n  }\r\n  \r\n  .modal-cancel-button:hover {\r\n    background-color: #6c7a7b;\r\n  }\r\n  \r\n  @media (max-width: 1024px) {\r\n    .template-page {\r\n      padding: 100px 40px 40px 40px;\r\n    }\r\n    \r\n    .template-container {\r\n      height: calc(100vh - 140px);\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .template-page {\r\n      padding: 80px 20px 20px 20px;\r\n    }\r\n    \r\n    .template-container {\r\n      height: calc(100vh - 100px);\r\n    }\r\n    \r\n    .template-header {\r\n      padding: 12px 20px;\r\n      min-height: 50px;\r\n    }\r\n    \r\n    .template-header h2 {\r\n      font-size: 18px;\r\n    }\r\n    \r\n    .template-messages {\r\n      padding: 20px;\r\n    }\r\n    \r\n    .message-row {\r\n      max-width: 90%;\r\n    }\r\n    \r\n    .template-input-container {\r\n      padding: 15px 20px;\r\n    }\r\n    \r\n    .modal-content {\r\n      width: 95%;\r\n      padding: 20px;\r\n    }\r\n    \r\n    .modal-buttons {\r\n      flex-direction: column;\r\n    }\r\n    \r\n    .modal-save-button,\r\n    .modal-delete-button,\r\n    .modal-cancel-button {\r\n      width: 100%;\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 480px) {\r\n    .template-page {\r\n      padding: 60px 15px 15px 15px;\r\n    }\r\n    \r\n    .template-header h2 {\r\n      font-size: 16px;\r\n    }\r\n    \r\n    .template-messages {\r\n      padding: 15px;\r\n    }\r\n    \r\n    .empty-state {\r\n      font-size: 16px;\r\n    }\r\n    \r\n    .message-content {\r\n      font-size: 14px;\r\n      padding: 10px 15px;\r\n    }\r\n    \r\n    .user-icon {\r\n      width: 32px;\r\n      height: 32px;\r\n    }\r\n    \r\n    .add-code-button {\r\n      width: 36px;\r\n      height: 36px;\r\n      font-size: 20px;\r\n    }\r\n    \r\n    .message-input {\r\n      padding: 10px 15px;\r\n      font-size: 14px;\r\n    }\r\n    \r\n    .send-button {\r\n      padding: 10px 20px;\r\n      font-size: 14px;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
